import { render, staticRenderFns } from "./RegisterWinnerDialog.vue?vue&type=template&id=386f3905&scoped=true"
import script from "./RegisterWinnerDialog.vue?vue&type=script&lang=js"
export * from "./RegisterWinnerDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterWinnerDialog.vue?vue&type=style&index=0&id=386f3905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f3905",
  null
  
)

export default component.exports